export default "__VITE_ASSET__DWyIZvox__"